import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "SiteFooterViewContainer"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EmdEnumValueListView = _resolveComponent("EmdEnumValueListView");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sites, site => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: `site_${site.value}`,
        label: site.label,
        name: site.label
      }, {
        default: _withCtx(() => [_createVNode(_component_EmdEnumValueListView, {
          type: "SITE_PAGE_FOOT",
          "show-title": false,
          sort: "",
          "init-query": {
            type: 'SITE_PAGE_FOOT',
            refId: site.value,
            sort: true,
            extra: true,
            labelSlot: true
          },
          title: "文章结尾列表",
          "add-btn": `添加${site.label}站点文章结尾`
        }, {
          extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra?.REMARK), 1)]),
          label: _withCtx(data => [_createElementVNode("span", {
            class: "ptr",
            style: {
              "color": "#009FFF"
            },
            onClick: $event => $options.gotoEdit(data.data)
          }, _toDisplayString(data.data.label), 9, _hoisted_2)]),
          _: 2
        }, 1032, ["init-query", "add-btn"])]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]);
}